import React, { FC } from 'react';
import { View } from 'react-native';
import { isWeb } from '@helpers';
import type { TourTargetProps, WebViewProps } from '@components/tours/types';

export const TourTarget: FC<TourTargetProps> = ({ tourId, children, style }) => {
  if (!isWeb) {
    // When style is provided, TourTarget is replacing a View (not wrapping one).
    // Must keep the View to preserve layout on native platforms.
    return style ? <View style={style}>{children}</View> : <>{children}</>;
  }

  const webProps: WebViewProps = {
    dataSet: { tourId },
    style,
  };

  return <View {...webProps}>{children}</View>;
};

export default TourTarget;
